import React from 'react';
import { X } from 'lucide-react';
export const WarningSignsSection = () => {
  return <section className="w-full bg-white px-5 py-10" data-id="element-210">
      <div className="max-w-md mx-auto" data-id="element-211">
        <div className="bg-gray-100 rounded-xl p-6 mb-8 shadow-sm" data-id="element-212">
          <h3 className="text-2xl font-bold text-pink-800 mb-5 leading-tight" data-id="element-213">
            Warning Signs Your Internal Moisture Deficit is Worsening:
          </h3>
          <div className="w-full rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-214">
            
          </div>
          <div className="space-y-4" data-id="element-215">
            <WarningItem text="You need lubricant every single time you are intimate." data-id="element-216" />
            <WarningItem text="You experience chafing or irritation from your underwear or pants." data-id="element-217" />
            <WarningItem text="A feeling of 'tightness' or 'sandpaper' during the day." data-id="element-218" />
            <WarningItem text="A pap smear or pelvic exam becomes increasingly painful." data-id="element-219" />
            <WarningItem text="You start avoiding intimacy altogether due to anticipated pain." data-id="element-220" />
          </div>
          <div className="bg-red-50 rounded-xl p-4 mt-6 border border-red-100" data-id="element-221">
            <p className="text-red-600 font-bold" data-id="element-222">
              Important: Every month you let this continue, the tissue thins
              further, making recovery longer and more difficult.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
const WarningItem = ({
  text
}: {
  text: string;
}) => {
  return;
};